function Users() {
    return (
      <div className="Users">
          <form>
              <div>First Name: <input type="text" name="First Name"/></div>
              <div>Last Name: <input type="text" name="Last Name"/></div>
              <input type="submit" value="Submit"></input>
          </form>
      </div>
    );
  }
  
  export default Users;
  